import React, { FC } from 'react';
import { DateTimePicker, DateTimePickerProps } from '@mui/x-date-pickers';
import { getDatePickerFormat } from 'utils/format';

type DataTableDateTimePickerProps = Omit<DateTimePickerProps<Date>, 'slotProps'>;

const DataTableDateTimePicker: FC<DataTableDateTimePickerProps> = (props) => {
    return (
        <DateTimePicker
            views={['year', 'day', 'hours', 'minutes']}
            ampm={false}
            format={getDatePickerFormat('datetime')}
            {...props}
            slotProps={{
                textField: {
                    variant: 'standard',
                    fullWidth: true,
                    sx: {
                        '& .MuiInputBase-root': {
                            padding: 0,
                            fontSize: '0.9rem',
                            overflow: 'hidden',
                        },
                        '& .MuiInputBase-input': {
                            padding: '4px 0 4px 8px',
                        },
                        '& .MuiInput-underline:before, & .MuiInput-underline:after': {
                            borderBottom: 'none',
                        },
                        '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                            borderBottom: 'none',
                        },
                        '& .MuiInputAdornment-root': {
                            margin: 0,
                        },
                        '& .MuiIconButton-root': {
                            padding: '4px',
                            marginRight: '2px',
                        },
                        '& .MuiSvgIcon-root': {
                            fontSize: '0.9rem',
                        },
                    },
                },
            }}
        />
    );
};

export default DataTableDateTimePicker;
